import React, { Component } from 'react'
import { Tabs, Avatar, Descriptions, Spin, Result, Button, Card, Tag, Row, Col, Empty, message, Input, Tree, Table, Drawer, Space, Typography, Badge, Modal, Alert, Collapse, Radio } from 'antd'
import {
    UserOutlined,
    KeyOutlined,
    FileTextOutlined,
    PhoneOutlined,
    BankOutlined,
    TeamOutlined,
    LockOutlined,
    IdcardOutlined,
    CopyOutlined,
    LeftOutlined,
    RightOutlined,
    SafetyCertificateOutlined,
    AppstoreOutlined,
    ApiOutlined,
    CloudServerOutlined,
    DatabaseOutlined,
    ReloadOutlined,
    LinkOutlined,
    EyeOutlined,
    PlusOutlined,
    UnorderedListOutlined,
    DeleteOutlined,
} from '@ant-design/icons'
import {
    getUserDetail,
    getMyVibeProjectSummary,
    applyMyGitlabAccount,
    getMyVibeProjectList,
    createMyVibeProject,
    retryMyVibeProject,
    getMyVibeProjectDetail,
    getMallMcpServices,
    getMallMcpServiceDetail,
    getMallSkillList,
    getMallSkillDetail,
    createSkillInstallTask,
    getMallApiList,
    getMallApiDetail,
} from '../../request'
import ApiKeyManagement from '../apiKey/ApiKeyManagement'
import { withRouter } from 'react-router-dom'
import { buildVibeGitlabCodexPrompt, buildVibeProjectCodexPrompt } from './vibeGitlabPrompt'
import { VIBE_DATASET_BOOTSTRAP_PROMPT } from './vibeDatasetBootstrapPrompt'
import { buildVibeProjectDetailParams, getCreatedVibeProjectId } from './vibeProjectDetail'
import VibeDatasetPanel from './VibeDatasetPanel'
import VibeProjectList from './VibeProjectList'
import VibeProjectDeleteDialog from './VibeProjectDeleteDialog'
import { canDeleteVibeProject } from './vibeProjectDelete'
import './index.less'

const { TabPane } = Tabs
const { Text } = Typography
const { Panel } = Collapse

const API_METHOD_COLOR = {
    GET: 'green',
    POST: 'blue',
    PUT: 'orange',
    DELETE: 'red',
    PATCH: 'purple',
}

const GENERIC_API_PATH_SEGMENTS = new Set(['api', 'openapi', 'rest', 'internal', 'v1', 'v2', 'v3'])
const VIBE_PROJECT_NAME_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,62}[a-z0-9])?$/
const VIBE_PROJECT_NAME_TIP = '项目名称只能包含小写英文、数字和短横线，不能包含空格，不能以短横线开头或结尾，最长64个字符'
const DEPLOYMENT_MODE_META = {
    server: { text: '服务器部署', color: 'blue' },
    local: { text: '仅本地运行', color: 'default' },
}
const PROJECT_KIND_META = {
    application: { text: '业务应用', color: 'blue' },
    dataset: { text: '共享数据集', color: 'cyan' },
}
const BUSINESS_SUBJECT_META = {
    lechun: { text: '乐纯', color: 'green' },
    superbody: { text: '超体', color: 'orange' },
}
const LEGACY_DEPLOY_PROMPT_INTRO = '请在你的业务项目目录里，把下面说明粘贴给 Codex 执行初始化。'
const DEPLOY_PROMPT_INTRO = `你现在要帮我初始化一个公司 VibeCoding 服务器部署项目。

这个项目需要部署到公司服务器上，通过 GitLab CI 构建 Docker 镜像，并发布到指定访问地址。`

// 信息主页：用户信息 + 快捷入口
function InfoTab({ userInfo, onTabSwitch, onPassword }) {
    const nickName = userInfo?.userNick || userInfo?.nickName || '-'
    const shortcuts = [
        {
            icon: <KeyOutlined style={{ fontSize: 22, color: '#1890ff' }} />,
            title: 'API Key 管理',
            desc: '查看和管理我的 API 密钥',
            onClick: () => onTabSwitch('apikey'),
        },
        {
            icon: <LockOutlined style={{ fontSize: 22, color: '#fa8c16' }} />,
            title: '修改密码',
            desc: '更新登录密码保障账号安全',
            onClick: onPassword,
        },
        {
            icon: <AppstoreOutlined style={{ fontSize: 22, color: '#722ed1' }} />,
            title: 'MCP 市场',
            desc: '浏览并接入公司内部 MCP 服务',
            onClick: () => onTabSwitch('mcpmarket'),
        },
        {
            icon: <ApiOutlined style={{ fontSize: 22, color: '#13c2c2' }} />,
            title: 'Skill 市场',
            desc: '浏览并安装公司内部 Skill',
            onClick: () => onTabSwitch('skillmarket'),
        },
        {
            icon: <CloudServerOutlined style={{ fontSize: 22, color: '#2f54eb' }} />,
            title: '我的 VibeCoding 空间',
            desc: '查看和申请我的业务小系统',
            onClick: () => onTabSwitch('vibedeploy'),
        },
        {
            icon: <UnorderedListOutlined style={{ fontSize: 22, color: '#531dab' }} />,
            title: 'Vibe 项目列表',
            desc: '查看全部项目及当前账号权限',
            onClick: () => onTabSwitch('vibeprojects'),
        },
        {
            icon: <CloudServerOutlined style={{ fontSize: 22, color: '#389e0d' }} />,
            title: 'API 市场',
            desc: '浏览当前角色可见的公司内部 API',
            onClick: () => onTabSwitch('apimarket'),
        },
    ]

    return (
        <div className="profile-info-wrap">
            <Row gutter={16}>
                {/* 账户信息 */}
                <Col xs={24} sm={12}>
                    <Card bordered={false} className="profile-info-card">
                        <div className="profile-info-card-title">
                            <SafetyCertificateOutlined /> 账户信息
                        </div>
                        <Descriptions column={1} size="small">
                            <Descriptions.Item label={<span><IdcardOutlined /> 用户ID</span>}>
                                {userInfo?.userId || userInfo?.id || '-'}
                            </Descriptions.Item>
                            <Descriptions.Item label={<span><UserOutlined /> 姓名</span>}>
                                {nickName}
                            </Descriptions.Item>
                            <Descriptions.Item label={<span><KeyOutlined /> 登录名</span>}>
                                {userInfo?.userName || userInfo?.loginName || '-'}
                            </Descriptions.Item>
                            <Descriptions.Item label={<span><PhoneOutlined /> 手机号</span>}>
                                {userInfo?.mobile || '-'}
                            </Descriptions.Item>
                        </Descriptions>
                    </Card>
                </Col>

                {/* 组织信息 */}
                <Col xs={24} sm={12}>
                    <Card bordered={false} className="profile-info-card">
                        <div className="profile-info-card-title">
                            <BankOutlined /> 组织信息
                        </div>
                        <Descriptions column={1} size="small">
                            <Descriptions.Item label={<span><BankOutlined /> 所属公司</span>}>
                                {userInfo?.platformGroupName || '-'}
                            </Descriptions.Item>
                            <Descriptions.Item label={<span><TeamOutlined /> 直属上级</span>}>
                                {userInfo?.leaderName || '-'}
                            </Descriptions.Item>
                        </Descriptions>
                    </Card>
                </Col>
            </Row>

            {/* 快捷入口 */}
            <div className="profile-shortcut-title">快捷入口</div>
            <Row gutter={16}>
                {shortcuts.map((item) => (
                    <Col xs={24} sm={8} key={item.title}>
                        <div className="profile-shortcut-card" onClick={item.onClick}>
                            <div className="profile-shortcut-icon">{item.icon}</div>
                            <div className="profile-shortcut-content">
                                <div className="profile-shortcut-name">{item.title}</div>
                                <div className="profile-shortcut-desc">{item.desc}</div>
                            </div>
                            <RightOutlined className="profile-shortcut-arrow" />
                        </div>
                    </Col>
                ))}
            </Row>
        </div>
    )
}

class ApiMarketTab extends Component {
    state = {
        loading: true,
        loadError: false,
        apis: [],
        detailVisible: false,
        detailLoading: false,
        selectedDetail: null,
        treeSelectedKey: 'all',
        filterKeyword: '',
    }

    componentDidMount() {
        this.loadApis()
    }

    loadApis = () => {
        this.setState({ loading: true, loadError: false })
        getMallApiList({})
            .then(res => {
                const apis = Array.isArray(res) ? res : (res?.list || [])
                this.setState({
                    apis,
                    loading: false,
                    selectedDetail: null,
                    detailVisible: false,
                })
            })
            .catch(() => {
                this.setState({ loading: false, loadError: true })
            })
    }

    loadDetail = (id) => {
        this.setState({ detailVisible: true, detailLoading: true })
        getMallApiDetail({ id })
            .then(res => {
                this.setState({
                    selectedDetail: res || null,
                    detailLoading: false,
                })
            })
            .catch(() => {
                message.error('API 详情加载失败')
                this.setState({ detailLoading: false })
            })
    }

    copyText = (text) => {
        if (!text) {
            message.warning('暂无可复制内容')
            return
        }
        if (navigator?.clipboard?.writeText) {
            navigator.clipboard.writeText(text)
                .then(() => message.success('已复制'))
                .catch(() => message.warning('复制失败，请手动复制'))
            return
        }
        message.warning('当前浏览器不支持自动复制，请手动复制')
    }

    renderApiStatusTag = (status) => {
        const normalized = (status || '').toLowerCase()
        if (normalized === 'enabled') return <Tag color="green">启用中</Tag>
        if (normalized === 'disabled') return <Tag>已停用</Tag>
        return <Tag color="blue">{status || '-'}</Tag>
    }

    renderPublicTag = (isPublic) => (
        <Tag color={isPublic ? 'geekblue' : 'default'}>
            {isPublic ? '公开' : '非公开'}
        </Tag>
    )

    getPathGroup = (path) => {
        const segments = String(path || '')
            .split('/')
            .map(item => item.trim())
            .filter(Boolean)
        const meaningful = segments.find(segment => !GENERIC_API_PATH_SEGMENTS.has(segment.toLowerCase()))
        return meaningful || '其他'
    }

    buildTreeKey = (type, sourceSystem, pathGroup) => {
        if (type === 'source') return `source::${encodeURIComponent(sourceSystem || 'unknown')}`
        if (type === 'group') return `group::${encodeURIComponent(sourceSystem || 'unknown')}::${encodeURIComponent(pathGroup || '其他')}`
        return 'all'
    }

    parseTreeSelection = (treeSelectedKey) => {
        if (!treeSelectedKey || treeSelectedKey === 'all') {
            return { sourceSystem: undefined, pathGroup: undefined }
        }
        const parts = String(treeSelectedKey).split('::')
        if (parts[0] === 'source') {
            return {
                sourceSystem: decodeURIComponent(parts[1] || ''),
                pathGroup: undefined,
            }
        }
        if (parts[0] === 'group') {
            return {
                sourceSystem: decodeURIComponent(parts[1] || ''),
                pathGroup: decodeURIComponent(parts[2] || ''),
            }
        }
        return { sourceSystem: undefined, pathGroup: undefined }
    }

    buildNavigationTree = () => {
        const grouped = this.state.apis.reduce((acc, item) => {
            const sourceSystem = item.sourceSystem || '未归类系统'
            const pathGroup = this.getPathGroup(item.path)
            if (!acc[sourceSystem]) acc[sourceSystem] = { count: 0, groups: {} }
            acc[sourceSystem].count += 1
            acc[sourceSystem].groups[pathGroup] = (acc[sourceSystem].groups[pathGroup] || 0) + 1
            return acc
        }, {})

        return Object.keys(grouped)
            .sort((a, b) => a.localeCompare(b))
            .map((sourceSystem) => ({
                key: this.buildTreeKey('source', sourceSystem),
                title: this.renderTreeTitle(sourceSystem, grouped[sourceSystem].count),
                children: Object.keys(grouped[sourceSystem].groups)
                    .sort((a, b) => a.localeCompare(b))
                    .map((pathGroup) => ({
                        key: this.buildTreeKey('group', sourceSystem, pathGroup),
                        title: this.renderTreeTitle(pathGroup, grouped[sourceSystem].groups[pathGroup], true),
                        isLeaf: true,
                    })),
            }))
    }

    renderTreeTitle = (label, count, compact) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, minWidth: 0 }}>
            <span style={{
                color: compact ? '#334155' : '#0f172a',
                fontWeight: compact ? 500 : 600,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            }}>
                {label}
            </span>
            <Tag color={compact ? 'default' : 'processing'} style={{ marginRight: 0 }}>
                {count}
            </Tag>
        </div>
    )

    getCurrentScopeLabel = () => {
        const { sourceSystem, pathGroup } = this.parseTreeSelection(this.state.treeSelectedKey)
        if (sourceSystem && pathGroup) return `${sourceSystem} / ${pathGroup}`
        if (sourceSystem) return sourceSystem
        return '全部接口'
    }

    getFilteredData = () => {
        const { apis, treeSelectedKey, filterKeyword } = this.state
        const keyword = (filterKeyword || '').trim().toLowerCase()
        const { sourceSystem, pathGroup } = this.parseTreeSelection(treeSelectedKey)
        return apis.filter((item) => {
            if (sourceSystem && item.sourceSystem !== sourceSystem) return false
            if (pathGroup && this.getPathGroup(item.path) !== pathGroup) return false
            if (!keyword) return true
            return [
                item.apiCode,
                item.apiName,
                item.path,
                item.baseUrl,
                item.sourceSystem,
                item.owner,
            ].some((field) => (field || '').toLowerCase().includes(keyword))
        })
    }

    buildApiUrl = (record) => {
        const baseUrl = String(record?.baseUrl || '').replace(/\/+$/, '')
        const path = String(record?.path || '').startsWith('/') ? String(record?.path || '') : `/${record?.path || ''}`
        if (!baseUrl && !record?.path) return '-'
        if (!baseUrl) return path
        return `${baseUrl}${path}`
    }

    parseRequestSchemaProperties = (requestSchema) => {
        if (!requestSchema) return []
        try {
            const schema = typeof requestSchema === 'string' ? JSON.parse(requestSchema) : requestSchema
            const properties = schema?.properties || {}
            return Object.keys(properties).map((name) => ({
                name,
                type: properties[name]?.type || '-',
                description: properties[name]?.description || '暂无描述',
            }))
        } catch (e) {
            return []
        }
    }

    buildApiAiBrief = (detail) => {
        if (!detail) return ''
        const requestParams = this.parseRequestSchemaProperties(detail.requestSchema)
        let responseSummary = '暂无响应 Schema'
        try {
            if (detail.responseSchema) {
                const responseSchema = typeof detail.responseSchema === 'string'
                    ? JSON.parse(detail.responseSchema)
                    : detail.responseSchema
                const responseProperties = Object.keys(responseSchema?.properties || {})
                responseSummary = responseProperties.length > 0
                    ? responseProperties.join('、')
                    : '已提供响应 Schema'
            }
        } catch (e) {
            responseSummary = '已提供响应 Schema'
        }

        const lines = [
            `接口名称：${detail.apiName || '-'}`,
            `接口编码：${detail.apiCode || '-'}`,
            `接口说明：${detail.description || detail.apiName || detail.apiCode || '-'}`,
            `来源系统：${detail.sourceSystem || '-'}`,
            `请求方式：${detail.method || '-'}`,
            `接口地址：${this.buildApiUrl(detail)}`,
            `接口版本：${detail.apiVersion || '-'}`,
            `负责人：${detail.owner || '-'}`,
            `简介：${detail.description || '暂无说明'}`,
            '',
            '调用鉴权：',
            '- 所有乐纯内部接口调用都需要带请求头：X-Caller-Key',
            '- X-Caller-Key 的取值来自你本机环境变量：LECHUN_API_KEY',
            '- 本地使用时可直接在请求头中写：X-Caller-Key: $LECHUN_API_KEY',
            '- 如果本机还没有配置 LECHUN_API_KEY，可先到以下页面获取或创建 API Key：',
            '- https://portal.lechun.cc/portal/profile?tab=apikey',
            '',
            '入参：',
        ]

        if (requestParams.length > 0) {
            requestParams.forEach((item) => {
                lines.push(`- ${item.name} | 类型：${item.type} | 说明：${item.description}`)
            })
        } else {
            lines.push('- 暂无请求参数')
        }

        lines.push('')
        lines.push(`出参摘要：${responseSummary}`)

        if (detail.requestSchema) {
            lines.push('')
            lines.push('请求 Schema：')
            lines.push(detail.requestSchema)
        }

        if (detail.responseSchema) {
            lines.push('')
            lines.push('响应 Schema：')
            lines.push(detail.responseSchema)
        }

        return lines.join('\n')
    }

    buildColumns = () => [
        {
            title: '接口信息',
            key: 'apiInfo',
            width: 460,
            render: (_, record) => (
                <div>
                    <div style={{ color: '#0f172a', fontSize: 15, fontWeight: 700, marginBottom: 8 }}>
                        {record.apiName || '-'}
                    </div>
                    <div style={{ marginBottom: 6 }}>
                        <Text code style={{ fontSize: 12 }}>{record.apiCode || '-'}</Text>
                    </div>
                    <div style={{ marginBottom: 6 }}>
                        <Text copyable style={{ fontSize: 12, color: '#475569' }}>
                            {this.buildApiUrl(record)}
                        </Text>
                    </div>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                        版本：{record.apiVersion || '-'}
                    </Text>
                </div>
            ),
        },
        {
            title: '参数',
            key: 'requestInfo',
            width: 420,
            render: (_, record) => {
                const params = this.parseRequestSchemaProperties(record.requestSchema)
                return (
                <div>
                    {params.length > 0 ? (
                        <Space direction="vertical" size={4} style={{ width: '100%' }}>
                            {params.slice(0, 3).map((item) => (
                                <div
                                    key={item.name}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6,
                                        minWidth: 0,
                                        lineHeight: 1.4,
                                    }}
                                >
                                    <Text strong style={{ color: '#0f172a', fontSize: 12, flexShrink: 0 }}>
                                        {item.name}
                                    </Text>
                                    <Tag color="blue" style={{ marginRight: 0, flexShrink: 0, lineHeight: '18px', padding: '0 6px' }}>
                                        {item.type}
                                    </Tag>
                                    <Text
                                        type="secondary"
                                        style={{
                                            fontSize: 12,
                                            minWidth: 0,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        }}
                                        title={item.description}
                                    >
                                        {item.description}
                                    </Text>
                                </div>
                            ))}
                            <Text type="secondary" style={{ fontSize: 12 }}>
                                共 {params.length} 个参数，详情查看全部
                            </Text>
                        </Space>
                    ) : (
                        <Space direction="vertical" size={6}>
                            <Badge status="default" text="暂无请求参数" />
                        </Space>
                    )}
                </div>
            )},
        },
        {
            title: '操作',
            key: 'action',
            width: 120,
            fixed: 'right',
            render: (_, record) => (
                <Button size="small" icon={<EyeOutlined />} onClick={() => this.loadDetail(record.id)}>
                    详情
                </Button>
            ),
        },
    ]

    renderToolbar = () => {
        const { filterKeyword } = this.state
        return (
            <div style={{
                display: 'flex',
                gap: 10,
                flexWrap: 'wrap',
                padding: 14,
                background: '#f8fafc',
                borderRadius: 16,
                border: '1px solid #eef2f7',
                marginBottom: 16,
            }}>
                <Input.Search
                    allowClear
                    value={filterKeyword}
                    placeholder="搜索接口名称、编码、路径、来源系统、负责人"
                    style={{ width: 320 }}
                    onChange={(e) => this.setState({ filterKeyword: e.target.value })}
                />
                <Button icon={<ReloadOutlined />} onClick={this.loadApis}>刷新</Button>
            </div>
        )
    }

    renderNavigation = () => {
        const treeData = this.buildNavigationTree()
        return (
            <Card
                bordered={false}
                style={{ borderRadius: 20, border: '1px solid #edf1f7', height: '100%' }}
                title={(
                    <Space>
                        <LinkOutlined style={{ color: '#1951d1' }} />
                        <span style={{ fontWeight: 600 }}>接口导航</span>
                    </Space>
                )}
                bodyStyle={{ padding: 14 }}
                extra={(
                    <Button
                        type={this.state.treeSelectedKey === 'all' ? 'primary' : 'default'}
                        size="small"
                        onClick={() => this.setState({ treeSelectedKey: 'all' })}
                    >
                        全部接口
                    </Button>
                )}
            >
                <div style={{
                    marginBottom: 12,
                    padding: '10px 12px',
                    borderRadius: 12,
                    background: '#f8fafc',
                    border: '1px solid #eef2f7',
                }}>
                    <div style={{ fontSize: 12, color: '#64748b', marginBottom: 4 }}>当前范围</div>
                    <div style={{ fontWeight: 600, color: '#0f172a' }}>{this.getCurrentScopeLabel()}</div>
                </div>
                {treeData.length > 0 ? (
                    <Tree
                        blockNode
                        selectedKeys={this.state.treeSelectedKey === 'all' ? [] : [this.state.treeSelectedKey]}
                        treeData={treeData}
                        onSelect={(selectedKeys) => this.setState({ treeSelectedKey: selectedKeys[0] || 'all' })}
                    />
                ) : (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无可导航的接口分类" />
                )}
            </Card>
        )
    }

    renderSchemaCard = (title, value, color) => (
        <Card
            size="small"
            bordered={false}
            title={(
                <Space>
                    <Tag color={color}>{title}</Tag>
                    <Text type="secondary" style={{ fontSize: 12 }}>JSON Schema</Text>
                </Space>
            )}
            style={{ borderRadius: 16, border: '1px solid #edf1f7' }}
        >
            {value ? (
                <pre style={{
                    margin: 0,
                    padding: 16,
                    background: '#0f172a',
                    color: '#e2e8f0',
                    borderRadius: 14,
                    fontSize: 12,
                    lineHeight: 1.7,
                    overflow: 'auto',
                    maxHeight: 320,
                }}>
                    {value}
                </pre>
            ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={`暂无${title}`} />
            )}
        </Card>
    )

    renderDetail = () => {
        const { detailVisible, selectedDetail, detailLoading } = this.state
        return (
            <Drawer
                width={820}
                visible={detailVisible}
                onClose={() => this.setState({ detailVisible: false, selectedDetail: null })}
                bodyStyle={{ padding: 20, background: '#f5f7fb' }}
                title={(
                    <Space>
                        <CloudServerOutlined />
                        <span>{selectedDetail?.apiName || '接口详情'}</span>
                    </Space>
                )}
            >
                {detailLoading ? (
                    <div style={{ padding: '28px 0', textAlign: 'center' }}>
                        <Spin />
                    </div>
                ) : selectedDetail ? (
                    <div>
                        <Card
                            bordered={false}
                            style={{ borderRadius: 18, border: '1px solid #edf1f7', marginBottom: 16 }}
                        >
                            <div className="profile-info-card-title" style={{ marginBottom: 12 }}>
                                <CopyOutlined /> 提供给 AI 的接口说明
                            </div>
                            <div style={{ marginBottom: 12, color: '#64748b', fontSize: 12 }}>
                                复制后可直接发送给 Codex 或其他 AI 工具，用于快速理解这个接口的用途、路径和出入参。
                            </div>
                            <Input.TextArea
                                readOnly
                                autoSize={{ minRows: 8, maxRows: 18 }}
                                value={this.buildApiAiBrief(selectedDetail)}
                            />
                            <div style={{ marginTop: 12 }}>
                                <Button
                                    type="primary"
                                    icon={<CopyOutlined />}
                                    onClick={() => this.copyText(this.buildApiAiBrief(selectedDetail))}
                                >
                                    复制给 AI
                                </Button>
                            </div>
                        </Card>
                        <Card
                            bordered={false}
                            style={{ borderRadius: 18, border: '1px solid #edf1f7', marginBottom: 16 }}
                        >
                            <Descriptions column={2} size="small" colon={false}>
                                <Descriptions.Item label="接口编码">{selectedDetail.apiCode || '-'}</Descriptions.Item>
                                <Descriptions.Item label="接口名称">{selectedDetail.apiName || '-'}</Descriptions.Item>
                                <Descriptions.Item label="来源系统">{selectedDetail.sourceSystem || '-'}</Descriptions.Item>
                                <Descriptions.Item label="负责人">{selectedDetail.owner || '-'}</Descriptions.Item>
                                <Descriptions.Item label="访问范围">{this.renderPublicTag(selectedDetail.isPublic)}</Descriptions.Item>
                                <Descriptions.Item label="请求方式">
                                    <Space size={8}>
                                        <Tag color={API_METHOD_COLOR[selectedDetail.method] || 'default'}>{selectedDetail.method}</Tag>
                                        <Tag>{(selectedDetail.protocol || 'http').toUpperCase()}</Tag>
                                    </Space>
                                </Descriptions.Item>
                                <Descriptions.Item label="接口状态">{this.renderApiStatusTag(selectedDetail.status)}</Descriptions.Item>
                                <Descriptions.Item label="接口版本">{selectedDetail.apiVersion || '-'}</Descriptions.Item>
                                <Descriptions.Item label="接口路径">
                                    <Text code>{selectedDetail.path || '-'}</Text>
                                </Descriptions.Item>
                                <Descriptions.Item label="Base URL">
                                    <Text copyable>{selectedDetail.baseUrl || '-'}</Text>
                                </Descriptions.Item>
                                <Descriptions.Item label="超时时间">{selectedDetail.timeoutMs || 0} ms</Descriptions.Item>
                            </Descriptions>
                        </Card>

                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                {this.renderSchemaCard('请求 Schema', selectedDetail.requestSchema, 'processing')}
                            </Col>
                            <Col span={24}>
                                {this.renderSchemaCard('响应 Schema', selectedDetail.responseSchema, 'success')}
                            </Col>
                        </Row>
                    </div>
                ) : null}
            </Drawer>
        )
    }

    render() {
        const { loading, loadError } = this.state
        const filteredData = this.getFilteredData()

        if (loadError) {
            return (
                <Result
                    status="error"
                    title="API 市场加载失败"
                    subTitle="无法获取 API 列表，请稍后重试"
                    extra={<Button type="primary" onClick={this.loadApis}>重试</Button>}
                />
            )
        }

        return (
            <div className="profile-market-wrap">
                <Spin spinning={loading}>
                    <Row gutter={[16, 16]} align="stretch">
                        <Col xs={24} xl={6}>
                            {this.renderNavigation()}
                        </Col>
                        <Col xs={24} xl={18}>
                            <Card
                                bordered={false}
                                style={{ borderRadius: 20, border: '1px solid #edf1f7' }}
                                title={(
                                    <Space>
                                        <ApiOutlined />
                                        <span>接口列表</span>
                                    </Space>
                                )}
                            >
                                {this.renderToolbar()}
                                <Table
                                    rowKey="id"
                                    columns={this.buildColumns()}
                                    dataSource={filteredData}
                                    pagination={{ pageSize: 10, showSizeChanger: false }}
                                    scroll={{ x: 1100 }}
                                />
                            </Card>
                        </Col>
                    </Row>
                    {this.renderDetail()}
                </Spin>
            </div>
        )
    }
}

class McpMarketTab extends Component {
    state = {
        loading: true,
        detailLoading: false,
        loadError: false,
        services: [],
        selectedId: null,
        selectedDetail: null,
        viewMode: 'list',
    }

    componentDidMount() {
        this.loadServices()
    }

    loadServices = () => {
        this.setState({ loading: true, loadError: false })
        getMallMcpServices({})
            .then(res => {
                const services = Array.isArray(res) ? res : (res?.list || [])
                this.setState({
                    services,
                    loading: false,
                    selectedId: null,
                    selectedDetail: null,
                    viewMode: 'list',
                })
            })
            .catch(() => {
                this.setState({ loading: false, loadError: true })
            })
    }

    openExternalLink = (url) => {
        window.open(url, '_blank')
    }

    loadDetail = (id) => {
        this.setState({ selectedId: id, detailLoading: true, viewMode: 'detail' })
        getMallMcpServiceDetail({ id })
            .then(res => {
                this.setState({
                    selectedDetail: res || null,
                    detailLoading: false,
                })
            })
            .catch(() => {
                message.error('MCP 服务详情加载失败')
                this.setState({ detailLoading: false })
            })
    }

    backToList = () => {
        this.setState({
            viewMode: 'list',
            detailLoading: false,
        })
    }

    copyText = (text) => {
        if (!text) {
            message.warning('暂无可复制内容')
            return
        }
        if (navigator?.clipboard?.writeText) {
            navigator.clipboard.writeText(text)
                .then(() => message.success('已复制'))
                .catch(() => message.warning('复制失败，请手动复制'))
            return
        }
        message.warning('当前浏览器不支持自动复制，请手动复制')
    }

    buildCodexPrompt = (detail) => {
        if (!detail?.installUrl || !detail?.serviceCode) {
            return ''
        }
        return `帮我执行:codex mcp add lechun-mcp-${detail.serviceCode} --url '${detail.installUrl}'`
    }

    renderStatusTag = (status) => {
        const normalized = (status || '').toLowerCase()
        if (normalized === 'enabled') return <Tag color="green">启用中</Tag>
        if (normalized === 'disabled') return <Tag>已停用</Tag>
        return <Tag color="blue">{status || '-'}</Tag>
    }

    renderServiceCard = (item) => {
        const isActive = item.id === this.state.selectedId
        return (
            <div
                key={item.id}
                className={`profile-market-service-card ${isActive ? 'active' : ''}`}
                onClick={() => this.loadDetail(item.id)}
            >
                <div className="profile-market-service-head">
                    <div className="profile-market-service-icon">
                        <CloudServerOutlined />
                    </div>
                    <div className="profile-market-service-main">
                        <div className="profile-market-service-name">{item.serviceName || '-'}</div>
                        <div className="profile-market-service-code">{item.serviceCode || '-'}</div>
                    </div>
                </div>
                <div className="profile-market-service-tags">
                    {this.renderStatusTag(item.status)}
                    <Tag color="blue">工具 {item.toolCount || 0}</Tag>
                    {item.installCommandAvailable ? <Tag color="purple">可接入</Tag> : null}
                </div>
                <div className="profile-market-service-desc">
                    {item.description || '暂无描述'}
                </div>
            </div>
        )
    }

    renderDetail = () => {
        const { selectedDetail, detailLoading } = this.state

        if (detailLoading) {
            return (
                <div className="profile-market-detail-empty">
                    <Spin />
                </div>
            )
        }

        if (!selectedDetail) return null

        const tools = selectedDetail.tools || []
        const codexPrompt = this.buildCodexPrompt(selectedDetail)

        return (
            <div className="profile-market-detail">
                <div className="profile-market-toolbar">
                    <div className="profile-market-toolbar-left">
                        <Button icon={<LeftOutlined />} onClick={this.backToList}>返回列表</Button>
                        <div className="profile-market-toolbar-title">MCP 详情</div>
                    </div>
                </div>

                <Card bordered={false} className="profile-market-detail-card profile-market-detail-hero">
                    <div className="profile-market-detail-hero-top">
                        <div className="profile-market-detail-icon">
                            <ApiOutlined />
                        </div>
                        <div className="profile-market-detail-title-wrap">
                            <div className="profile-market-detail-title">{selectedDetail.serviceName || '-'}</div>
                            <div className="profile-market-detail-subtitle">{selectedDetail.serviceCode || '-'}</div>
                            <div className="profile-market-detail-tags">
                                {this.renderStatusTag(selectedDetail.status)}
                                <Tag color="blue">工具 {selectedDetail.toolCount || 0}</Tag>
                            </div>
                        </div>
                    </div>
                    <div className="profile-market-detail-desc">
                        {selectedDetail.description || '暂无服务描述'}
                    </div>
                </Card>

                <Row gutter={16} className="profile-market-detail-content">
                    <Col xs={24} xl={16}>
                        <Card bordered={false} className="profile-market-detail-card profile-market-detail-tabs-card">
                            <Tabs defaultActiveKey="intro" className="profile-market-detail-tabs">
                                <TabPane tab="MCP介绍" key="intro">
                                    <div className="profile-market-intro-block">
                                        <div className="profile-info-card-title">
                                            <ApiOutlined /> MCP介绍
                                        </div>
                                        <div className="profile-market-intro-desc">
                                            {selectedDetail.description || '暂无 MCP 介绍'}
                                        </div>
                                    </div>
                                </TabPane>

                                <TabPane tab="工具" key="tools">
                                    {tools.length > 0 ? (
                                        <div className="profile-market-tool-list">
                                            {tools.map(tool => (
                                                <div className="profile-market-tool-item" key={tool.id || tool.toolCode}>
                                                    <div className="profile-market-tool-top">
                                                        <div className="profile-market-tool-name">{tool.name || tool.toolCode || '-'}</div>
                                                        <Tag color={tool.status === 'published' ? 'green' : 'blue'}>
                                                            {tool.status || '-'}
                                                        </Tag>
                                                    </div>
                                                    <div className="profile-market-tool-meta">
                                                        <span>{tool.toolCode || '-'}</span>
                                                        <span>{tool.category || '未分类'}</span>
                                                        <span>{tool.currentVersion || '未发布版本'}</span>
                                                    </div>
                                                    <div className="profile-market-tool-desc">
                                                        {tool.description || '暂无工具描述'}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <Empty description="当前服务暂无可展示工具" />
                                    )}
                                </TabPane>
                            </Tabs>
                        </Card>
                    </Col>
                    <Col xs={24} xl={8}>
                        <div className="profile-market-side-block">
                            <Card bordered={false} className="profile-market-detail-card">
                                <div className="profile-info-card-title">
                                    <CopyOutlined /> 使用MCP
                                </div>
                                <div className="profile-market-install-panel">
                                    <div className="profile-market-install-label">codex安装指令</div>
                                    <Input.TextArea
                                        readOnly
                                        autoSize={{ minRows: 4, maxRows: 6 }}
                                        value={codexPrompt || '当前账号暂无可用 API Key，暂不生成 codex 安装指令'}
                                        className="profile-market-install-textarea"
                                    />
                                    <div className="profile-market-install-actions">
                                        <Button
                                            type="primary"
                                            icon={<CopyOutlined />}
                                            disabled={!codexPrompt}
                                            onClick={() => this.copyText(codexPrompt)}
                                        >
                                            复制
                                        </Button>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }

    render() {
        const { loading, loadError, services, viewMode } = this.state

        if (loadError) {
            return (
                <Result
                    status="error"
                    title="MCP 市场加载失败"
                    subTitle="无法获取服务列表，请稍后重试"
                    extra={<Button type="primary" onClick={this.loadServices}>重试</Button>}
                />
            )
        }

        return (
            <div className="profile-market-wrap">
                <Spin spinning={loading}>
                    {viewMode === 'list' ? (
                        <>
                            <div className="profile-market-toolbar">
                                <div className="profile-market-toolbar-title">MCP 市场</div>
                                <Space>
                                    <Button onClick={() => this.openExternalLink('https://aihub.dingtalk.com/#/mcp')}>钉钉MCP</Button>
                                    <Button icon={<ReloadOutlined />} onClick={this.loadServices}>刷新</Button>
                                </Space>
                            </div>

                            {services.length > 0 ? (
                                <div className="profile-market-grid">
                                    {services.map(this.renderServiceCard)}
                                </div>
                            ) : (
                                <Card bordered={false} className="profile-market-list-card">
                                    <Empty description="暂无可用 MCP 服务" />
                                </Card>
                            )}
                        </>
                    ) : this.renderDetail()}
                </Spin>
            </div>
        )
    }
}

class SkillMarketTab extends Component {
    state = {
        loading: true,
        detailLoading: false,
        loadError: false,
        skills: [],
        selectedId: null,
        selectedDetail: null,
        viewMode: 'list',
    }

    componentDidMount() {
        this.loadSkills()
    }

    loadSkills = () => {
        this.setState({ loading: true, loadError: false })
        getMallSkillList({})
            .then(res => {
                const skills = Array.isArray(res) ? res : (res?.list || [])
                this.setState({
                    skills,
                    loading: false,
                    selectedId: null,
                    selectedDetail: null,
                    viewMode: 'list',
                })
            })
            .catch(() => {
                this.setState({ loading: false, loadError: true })
            })
    }

    openSkillAdmin = () => {
        window.open(
            'https://portal.lechun.cc/portal/lcpagesystem?url=https%3A%2F%2Fdata.lechun.cc%2FskillAdmin',
            '_blank'
        )
    }

    openExternalLink = (url) => {
        window.open(url, '_blank')
    }

    loadDetail = (id) => {
        this.setState({ selectedId: id, detailLoading: true, viewMode: 'detail' })
        getMallSkillDetail({ id })
            .then(async res => {
                let detail = res || null
                if (detail?.id && detail?.currentVersionId) {
                    try {
                        const installTaskResult = await createSkillInstallTask({
                            skillId: detail.id,
                            versionId: detail.currentVersionId,
                            actionType: 'install',
                        })
                        if (installTaskResult) {
                            detail = {
                                ...detail,
                                installPrompt: installTaskResult.installPrompt || detail.installPrompt,
                                installPath: installTaskResult.installPath || detail.installPath,
                                installTask: installTaskResult.task || detail.installTask,
                                installTaskId: installTaskResult?.task?.id || detail.installTaskId,
                                installPromptAvailable: !!(installTaskResult.installPrompt || detail.installPrompt),
                            }
                        }
                    } catch (error) {
                        message.warning('Skill 安装任务创建失败，已展示默认安装提示')
                    }
                }
                this.setState({
                    selectedDetail: detail,
                    detailLoading: false,
                })
            })
            .catch(() => {
                message.error('Skill 详情加载失败')
                this.setState({ detailLoading: false })
            })
    }

    backToList = () => {
        this.setState({
            viewMode: 'list',
            detailLoading: false,
        })
    }

    copyText = (text) => {
        if (!text) {
            message.warning('暂无可复制内容')
            return
        }
        if (navigator?.clipboard?.writeText) {
            navigator.clipboard.writeText(text)
                .then(() => message.success('已复制'))
                .catch(() => message.warning('复制失败，请手动复制'))
            return
        }
        message.warning('当前浏览器不支持自动复制，请手动复制')
    }

    renderSkillStatusTag = (status) => {
        if (status === 1) return <Tag color="green">启用中</Tag>
        if (status === 2) return <Tag>已停用</Tag>
        if (status === 3) return <Tag>已归档</Tag>
        return <Tag color="blue">草稿</Tag>
    }

    renderVersionStatusTag = (status) => {
        if (status === 2) return <Tag color="green">已发布</Tag>
        if (status === 1) return <Tag color="gold">待审核</Tag>
        if (status === 3) return <Tag>已下线</Tag>
        if (status === 4) return <Tag color="blue">待发布</Tag>
        return <Tag>草稿</Tag>
    }

    renderSkillCard = (item) => {
        const isActive = item.id === this.state.selectedId
        return (
            <div
                key={item.id}
                className={`profile-market-service-card ${isActive ? 'active' : ''}`}
                onClick={() => this.loadDetail(item.id)}
            >
                <div className="profile-market-service-head">
                    <div className="profile-market-service-icon">
                        <ApiOutlined />
                    </div>
                    <div className="profile-market-service-main">
                        <div className="profile-market-service-name">{item.skillName || '-'}</div>
                        <div className="profile-market-service-code">{item.skillCode || '-'}</div>
                    </div>
                </div>
                <div className="profile-market-service-tags">
                    {this.renderSkillStatusTag(item.status)}
                    <Tag color="blue">版本 {item.versionCount || 0}</Tag>
                </div>
                <div className="profile-market-service-desc">
                    {item.description || '暂无描述'}
                </div>
            </div>
        )
    }

    renderDetail = () => {
        const { selectedDetail, detailLoading } = this.state

        if (detailLoading) {
            return (
                <div className="profile-market-detail-empty">
                    <Spin />
                </div>
            )
        }

        if (!selectedDetail) return null

        const versions = selectedDetail.versions || []
        const installPrompt = selectedDetail.installPrompt || ''

        return (
            <div className="profile-market-detail">
                <div className="profile-market-toolbar">
                    <div className="profile-market-toolbar-left">
                        <Button icon={<LeftOutlined />} onClick={this.backToList}>返回列表</Button>
                        <div className="profile-market-toolbar-title">Skill 详情</div>
                    </div>
                </div>

                <Card bordered={false} className="profile-market-detail-card profile-market-detail-hero">
                    <div className="profile-market-detail-hero-top">
                        <div className="profile-market-detail-icon">
                            <ApiOutlined />
                        </div>
                        <div className="profile-market-detail-title-wrap">
                            <div className="profile-market-detail-title">{selectedDetail.skillName || '-'}</div>
                            <div className="profile-market-detail-subtitle">{selectedDetail.skillCode || '-'}</div>
                            <div className="profile-market-detail-tags">
                                {this.renderSkillStatusTag(selectedDetail.status)}
                                <Tag color="blue">版本 {selectedDetail.versionCount || 0}</Tag>
                                {selectedDetail.currentVersionNo ? <Tag color="cyan">当前 {selectedDetail.currentVersionNo}</Tag> : null}
                            </div>
                        </div>
                    </div>
                    <div className="profile-market-detail-desc">
                        {selectedDetail.description || '暂无 Skill 描述'}
                    </div>
                </Card>

                <Row gutter={16} className="profile-market-detail-content">
                    <Col xs={24} xl={16}>
                        <Card bordered={false} className="profile-market-detail-card profile-market-detail-tabs-card">
                            <Tabs defaultActiveKey="intro" className="profile-market-detail-tabs">
                                <TabPane tab="Skill介绍" key="intro">
                                    <div className="profile-market-intro-block">
                                        <div className="profile-info-card-title">
                                            <ApiOutlined /> Skill介绍
                                        </div>
                                        <div className="profile-market-intro-desc">
                                            {selectedDetail.detailMarkdown || selectedDetail.description || '暂无 Skill 介绍'}
                                        </div>
                                    </div>
                                </TabPane>

                                <TabPane tab="版本" key="versions">
                                    {versions.length > 0 ? (
                                        <div className="profile-market-tool-list">
                                            {versions.map(version => (
                                                <div className="profile-market-tool-item" key={version.id || version.versionNo}>
                                                    <div className="profile-market-tool-top">
                                                        <div className="profile-market-tool-name">{version.versionNo || '-'}</div>
                                                        {this.renderVersionStatusTag(version.status)}
                                                    </div>
                                                    <div className="profile-market-tool-meta">
                                                        <span>{version.packageName || '未配置安装包名称'}</span>
                                                        <span>{version.packageUrl || '未配置安装包地址'}</span>
                                                    </div>
                                                    <div className="profile-market-tool-desc">
                                                        {version.changelog || '暂无版本说明'}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <Empty description="当前 Skill 暂无可展示版本" />
                                    )}
                                </TabPane>
                            </Tabs>
                        </Card>
                    </Col>
                    <Col xs={24} xl={8}>
                        <div className="profile-market-side-block">
                            <Card bordered={false} className="profile-market-detail-card">
                                <div className="profile-info-card-title">
                                    <CopyOutlined /> 使用Skill
                                </div>
                                <div className="profile-market-install-panel">
                                    <div className="profile-market-install-label">codex安装指令</div>
                                    <Input.TextArea
                                        readOnly
                                        autoSize={{ minRows: 8, maxRows: 14 }}
                                        value={installPrompt || '当前版本暂无可用安装提示'}
                                        className="profile-market-install-textarea"
                                    />
                                    <div className="profile-market-install-actions">
                                        <Button
                                            type="primary"
                                            icon={<CopyOutlined />}
                                            disabled={!installPrompt}
                                            onClick={() => this.copyText(installPrompt)}
                                        >
                                            复制
                                        </Button>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }

    render() {
        const { loading, loadError, skills, viewMode } = this.state

        if (loadError) {
            return (
                <Result
                    status="error"
                    title="Skill 市场加载失败"
                    subTitle="无法获取 Skill 列表，请稍后重试"
                    extra={<Button type="primary" onClick={this.loadSkills}>重试</Button>}
                />
            )
        }

        return (
            <div className="profile-market-wrap">
                <Spin spinning={loading}>
                    {viewMode === 'list' ? (
                        <>
                            <div className="profile-market-toolbar">
                                <div className="profile-market-toolbar-title">Skill 市场</div>
                                <Space>
                                    <Button onClick={() => this.openExternalLink('https://aihub.dingtalk.com/#/skill')}>钉钉Skill</Button>
                                    <Button onClick={() => this.openExternalLink('https://github.com/DingTalk-Real-AI/dingtalk-workspace-cli/blob/main/README_zh.md')}>钉钉CLI</Button>
                                    <Button onClick={this.openSkillAdmin}>上传我的Skill</Button>
                                    <Button icon={<ReloadOutlined />} onClick={this.loadSkills}>刷新</Button>
                                </Space>
                            </div>

                            {skills.length > 0 ? (
                                <div className="profile-market-grid">
                                    {skills.map(this.renderSkillCard)}
                                </div>
                            ) : (
                                <Card bordered={false} className="profile-market-list-card">
                                    <Empty description="暂无可用 Skill" />
                                </Card>
                            )}
                        </>
                    ) : this.renderDetail()}
                </Spin>
            </div>
        )
    }
}

class VibeDeployTab extends Component {
    state = {
        loading: true,
        loadError: false,
        summary: null,
        projects: [],
        detailVisible: false,
        detailLoading: false,
        selectedDetail: null,
        createVisible: false,
        createLoading: false,
        applyLoading: false,
        retryLoading: false,
        deleteVisible: false,
        deleteProject: null,
        projectName: '',
        description: '',
        deploymentMode: 'server',
        businessSubject: 'lechun',
    }

    componentDidMount() {
        this.loadData()
    }

    loadData = () => {
        this.setState({ loading: true, loadError: false })
        Promise.all([
            getMyVibeProjectSummary({}),
            getMyVibeProjectList({}),
        ])
            .then(([summary, projects]) => {
                this.setState({
                    summary: summary || null,
                    projects: Array.isArray(projects) ? projects : [],
                    loading: false,
                })
            })
            .catch(() => {
                this.setState({ loading: false, loadError: true })
            })
    }

    loadDetail = (id) => {
        this.setState({ detailVisible: true, detailLoading: true, selectedDetail: null })
        getMyVibeProjectDetail(buildVibeProjectDetailParams(id))
            .then(res => {
                this.setState({
                    selectedDetail: res || null,
                    detailLoading: false,
                })
            })
            .catch(() => {
                message.error('项目详情加载失败')
                this.setState({ detailLoading: false })
            })
    }

    refreshSelectedDetail = () => {
        const projectId = this.state.selectedDetail?.id
        this.loadData()
        if (!projectId) return
        getMyVibeProjectDetail(buildVibeProjectDetailParams(projectId))
            .then(res => {
                if (String(this.state.selectedDetail?.id) === String(projectId)) {
                    this.setState({ selectedDetail: res || this.state.selectedDetail })
                }
            })
            .catch(() => {})
    }

    manageSelectedProjectPermissions = () => {
        const projectId = this.state.selectedDetail?.id
        if (projectId && this.props.onManageProjectPermissions) {
            this.props.onManageProjectPermissions(projectId)
        } else if (this.props.onTabSwitch) {
            this.props.onTabSwitch('vibeprojects')
        }
    }

    openPageAccess = (project, event) => {
        event.stopPropagation()
        if (this.props.onConfigurePageAccess) {
            this.props.onConfigurePageAccess(project)
        }
    }

    openCreate = () => {
        this.setState({
            createVisible: true,
            projectName: '',
            description: '',
            deploymentMode: 'server',
            businessSubject: 'lechun',
        })
    }

    closeCreate = () => {
        this.setState({
            createVisible: false,
            createLoading: false,
        })
    }

    applyGitlabAccount = () => {
        this.setState({ applyLoading: true })
        applyMyGitlabAccount({})
            .then(() => {
                message.success('VibeCoding 空间已开通')
                this.setState({ applyLoading: false })
                this.loadData()
            })
            .catch(() => {
                this.setState({ applyLoading: false })
            })
    }

    createProject = () => {
        const {
            projectName,
            description,
            deploymentMode,
            businessSubject,
        } = this.state
        if (!projectName || !projectName.trim()) {
            message.warning('请填写项目名称')
            return
        }
        if (!VIBE_PROJECT_NAME_PATTERN.test(projectName.trim())) {
            message.warning(VIBE_PROJECT_NAME_TIP)
            return
        }
        if (!DEPLOYMENT_MODE_META[deploymentMode]) {
            message.warning('请选择运行方式')
            return
        }
        if (!BUSINESS_SUBJECT_META[businessSubject]) {
            message.warning('请选择主体')
            return
        }
        this.setState({ createLoading: true })
        const createRequest = {
            projectName: projectName.trim(),
            description: description ? description.trim() : '',
            projectKind: 'application',
            deploymentMode,
            businessSubject,
        }
        createMyVibeProject(createRequest)
            .then(res => {
                message.success('项目已创建')
                const createdProjectId = getCreatedVibeProjectId(res)
                this.setState({
                    createVisible: false,
                    createLoading: false,
                    projectName: '',
                    description: '',
                    deploymentMode: 'server',
                    businessSubject: 'lechun',
                })
                this.loadData()
                if (createdProjectId) {
                    this.loadDetail(createdProjectId)
                }
            })
            .catch(() => {
                this.setState({ createLoading: false })
            })
    }

    retryProject = () => {
        const { selectedDetail } = this.state
        if (!selectedDetail?.id) {
            message.warning('项目ID不存在，无法重试')
            return
        }
        this.setState({ retryLoading: true })
        retryMyVibeProject({ id: selectedDetail.id })
            .then(res => {
                message.success('已重新执行接入')
                this.setState({
                    retryLoading: false,
                    selectedDetail: res || selectedDetail,
                })
                this.loadData()
                this.loadDetail(selectedDetail.id)
            })
            .catch(() => {
                this.setState({ retryLoading: false })
            })
    }

    openProjectDelete = (project, event) => {
        if (event) event.stopPropagation()
        this.setState({
            deleteVisible: true,
            deleteProject: project,
        })
    }

    closeProjectDelete = () => {
        this.setState({
            deleteVisible: false,
            deleteProject: null,
        })
    }

    copyText = (text) => {
        if (!text) {
            message.warning('暂无可复制内容')
            return
        }
        if (navigator?.clipboard?.writeText) {
            navigator.clipboard.writeText(text)
                .then(() => message.success('已复制'))
                .catch(() => message.warning('复制失败，请手动复制'))
            return
        }
        message.warning('当前浏览器不支持自动复制，请手动复制')
    }

    formatVibeInstructionText = (text) => {
        if (!text) return text
        return String(text)
            .replace(/\\r\\n/g, '\n')
            .replace(/\\n/g, '\n')
            .replace(/\\"/g, '"')
            .replace(LEGACY_DEPLOY_PROMPT_INTRO, DEPLOY_PROMPT_INTRO)
    }

    renderInstructionPanel = (key, title, hint, instruction) => {
        if (!instruction) return null
        return (
            <Panel
                key={key}
                header={(
                    <div className="profile-vibe-card-title">
                        <CopyOutlined /> {title}
                        <span className="profile-vibe-instruction-hint">{hint}</span>
                    </div>
                )}
            >
                <div className="profile-vibe-bootstrap-actions">
                    <Button
                        type="primary"
                        icon={<CopyOutlined />}
                        onClick={() => this.copyText(instruction)}
                    >
                        复制提示词
                    </Button>
                </div>
                <pre className="profile-vibe-instruction">{instruction}</pre>
            </Panel>
        )
    }

    renderStatusTag = (status) => {
        const normalized = (status || '').toLowerCase()
        const statusMap = {
            approved: { color: 'green', label: '已创建' },
            provisioning: { color: 'processing', label: '接入中' },
            ready: { color: 'green', label: '已就绪' },
            failed: { color: 'red', label: '接入失败' },
            deleting: { color: 'red', label: '删除中' },
            disabled: { color: 'default', label: '已停用' },
            deleted: { color: 'default', label: '已删除' },
        }
        const option = statusMap[normalized] || { color: 'blue', label: status || '-' }
        return <Tag color={option.color}>{option.label}</Tag>
    }

    renderMysqlStatusTag = (status) => {
        const normalized = (status || '').toLowerCase()
        if (normalized === 'created') return <Tag color="green">已创建</Tag>
        if (normalized === 'existing') return <Tag color="blue">已绑定</Tag>
        if (normalized === 'failed') return <Tag color="red">配置失败</Tag>
        return <Tag color="default">{status || '-'}</Tag>
    }

    formatDate = (value) => {
        if (!value) return '-'
        const date = new Date(value)
        if (Number.isNaN(date.getTime())) return String(value)
        const pad = (num) => (num < 10 ? `0${num}` : String(num))
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
    }

    renderAccountCard = () => {
        const { summary, applyLoading } = this.state
        const spaceEnabled = summary?.spaceEnabled !== undefined ? !!summary.spaceEnabled : !!summary?.gitlabEnabled
        return (
            <Card bordered={false} className="profile-vibe-account-card">
                <div className="profile-vibe-card-head">
                    <div className="profile-vibe-card-title">
                        <CloudServerOutlined /> 我的 VibeCoding 空间
                    </div>
                    {spaceEnabled ? <Tag color="green">已开通</Tag> : <Tag color="gold">未开通</Tag>}
                </div>
                {spaceEnabled ? (
                    <>
                        <Descriptions column={2} size="small">
                            <Descriptions.Item label="空间账号">{summary?.gitlabUsername || '-'}</Descriptions.Item>
                            <Descriptions.Item label="邮箱">{summary?.gitlabEmail || '-'}</Descriptions.Item>
                            <Descriptions.Item label="数据库账号">{summary?.vibeMysqlUsername || '-'}</Descriptions.Item>
                            <Descriptions.Item label="项目总数">{summary?.total || 0}</Descriptions.Item>
                        </Descriptions>
                        {this.renderGitlabBootstrapPrompt()}
                    </>
                ) : (
                    <Result
                        status="warning"
                        title="未开通 VibeCoding 空间"
                        subTitle="开通后可自动创建自己的 Vibe 项目仓库和项目数据库。"
                        extra={(
                            <Button
                                type="primary"
                                loading={applyLoading}
                                onClick={this.applyGitlabAccount}
                            >
                                开通 VibeCoding 空间
                            </Button>
                        )}
                    />
                )}
            </Card>
        )
    }

    renderGitlabBootstrapPrompt = () => {
        const { summary, applyLoading } = this.state
        if (!summary?.gitlabCredentialsReady) {
            return (
                <Alert
                    className="profile-vibe-bootstrap-missing"
                    type="warning"
                    showIcon
                    message="空间初始化凭据还没有生成"
                    description="点击生成后，页面会展示调用动态接口的 Codex 启动提示词。"
                    action={(
                        <Button size="small" type="primary" loading={applyLoading} onClick={this.applyGitlabAccount}>
                            生成初始化凭据
                        </Button>
                    )}
                />
            )
        }

        const prompt = buildVibeGitlabCodexPrompt()
        return (
            <div className="profile-vibe-bootstrap">
                <Collapse
                    bordered={false}
                    defaultActiveKey={[]}
                    className="profile-vibe-bootstrap-collapse"
                >
                    <Panel
                        key="bootstrap"
                        header={(
                            <div className="profile-vibe-card-title">
                                <CopyOutlined /> Codex 空间初始化启动提示词，可重复执行并自动获取最新内容。
                            </div>
                        )}
                    >
                        <div className="profile-vibe-bootstrap-actions">
                            <Button
                                type="primary"
                                icon={<CopyOutlined />}
                                onClick={() => this.copyText(prompt)}
                            >
                                复制提示词
                            </Button>
                        </div>
                        <pre className="profile-vibe-instruction">{prompt}</pre>
                    </Panel>
                </Collapse>
            </div>
        )
    }

    renderDatasetBootstrapPrompt = () => (
        <Alert
            className="profile-vibe-dataset-bootstrap"
            type="info"
            showIcon
            icon={<DatabaseOutlined />}
            message="AIC业务数据登记"
            description={(
                <div className="profile-vibe-dataset-bootstrap-content">
                    <span className="profile-vibe-dataset-bootstrap-note">
                        复制提示词给 Codex，再将 AIC 规划 Markdown 提供给它。
                        Codex 会读取数据资产表，预览确认后按一行一个项目登记；Markdown 文件本身不会上传。
                    </span>
                    <Button
                        type="primary"
                        icon={<CopyOutlined />}
                        onClick={() => this.copyText(VIBE_DATASET_BOOTSTRAP_PROMPT)}
                    >
                        复制创建提示词
                    </Button>
                </div>
            )}
        />
    )

    getDeploymentMode = (project) => project?.deploymentMode === 'local' ? 'local' : 'server'

    getProjectKind = (project) => project?.projectKind === 'dataset' ? 'dataset' : 'application'

    getBusinessSubject = (project) => project?.businessSubject === 'superbody' ? 'superbody' : 'lechun'

    renderDeploymentModeTag = (project) => {
        const meta = DEPLOYMENT_MODE_META[this.getDeploymentMode(project)]
        return <Tag color={meta.color}>{meta.text}</Tag>
    }

    renderProjectKindTag = (project) => {
        const meta = PROJECT_KIND_META[this.getProjectKind(project)]
        return <Tag color={meta.color}>{meta.text}</Tag>
    }

    renderBusinessSubjectTag = (project) => {
        const meta = BUSINESS_SUBJECT_META[this.getBusinessSubject(project)]
        return <Tag color={meta.color}>{meta.text}</Tag>
    }

    renderProjectCard = (item) => {
        const datasetProject = this.getProjectKind(item) === 'dataset'
        const serverDeployment = !datasetProject && this.getDeploymentMode(item) === 'server'
        return (
            <div className="profile-vibe-project-card" key={item.id} onClick={() => this.loadDetail(item.id)}>
                <div className="profile-vibe-card-head">
                    <div className="profile-vibe-card-title">{item.projectName || '-'}</div>
                    <Space size={4}>
                        {this.renderStatusTag(item.status)}
                        {canDeleteVibeProject(item, this.props.userInfo) ? (
                            <Button
                                type="link"
                                danger
                                size="small"
                                icon={<DeleteOutlined />}
                                onClick={(event) => this.openProjectDelete(item, event)}
                            >
                                {item.status === 'deleting' ? '查看删除' : '删除'}
                            </Button>
                        ) : null}
                    </Space>
                </div>
                <div className="profile-vibe-project-desc">{item.description || '暂无项目简介'}</div>
                <div className="profile-vibe-meta">
                    <div><span>Slug</span><Text code>{item.projectSlug || '-'}</Text></div>
                    <div><span>项目用途</span>{this.renderProjectKindTag(item)}</div>
                    <div><span>运行方式</span>{this.renderDeploymentModeTag(item)}</div>
                    <div><span>主体</span>{this.renderBusinessSubjectTag(item)}</div>
                    {serverDeployment ? <div><span>访问地址</span><Text copyable={!!item.publicUrl}>{item.publicUrl || '-'}</Text></div> : null}
                    <div><span>{datasetProject ? '共享数据库' : '数据库'}</span><Text code copyable={!!item.mysqlDatabaseName}>{item.mysqlDatabaseName || '-'}</Text></div>
                    {serverDeployment ? <div><span>basePath</span><Text code>{item.basePath || '-'}</Text></div> : null}
                    {serverDeployment ? (
                        <div>
                            <span>页面访问权限</span>
                            <Button
                                className="profile-vibe-page-access-link"
                                type="link"
                                size="small"
                                icon={<SafetyCertificateOutlined />}
                                onClick={(event) => this.openPageAccess(item, event)}
                            >配置</Button>
                        </div>
                    ) : null}
                    <div><span>创建时间</span><Text>{this.formatDate(item.createTime)}</Text></div>
                </div>
            </div>
        )
    }

    renderCreateModal = () => {
        const {
            createVisible,
            createLoading,
            projectName,
            description,
            deploymentMode,
            businessSubject,
        } = this.state
        return (
            <Modal
                visible={createVisible}
                title="新增 Vibe 项目"
                width={620}
                confirmLoading={createLoading}
                onCancel={this.closeCreate}
                onOk={this.createProject}
                okText="创建"
                cancelText="取消"
                destroyOnClose
            >
                <Space direction="vertical" size={12} style={{ width: '100%' }}>
                    <div>
                        <div className="profile-vibe-form-label">项目名称</div>
                        <Input
                            value={projectName}
                            maxLength={64}
                            placeholder="例如 sales-report，必须和项目文件夹名一致"
                            onChange={(e) => this.setState({ projectName: e.target.value })}
                        />
                        <div className="profile-vibe-form-tip">{VIBE_PROJECT_NAME_TIP}</div>
                    </div>
                    <div>
                        <div className="profile-vibe-form-label">项目简介/备注</div>
                        <Input.TextArea
                            value={description}
                            maxLength={500}
                            autoSize={{ minRows: 4, maxRows: 8 }}
                            placeholder="简单说明这个业务小系统的用途"
                            onChange={(e) => this.setState({ description: e.target.value })}
                        />
                    </div>
                    <div>
                        <div className="profile-vibe-form-label">运行方式</div>
                        <Radio.Group
                            value={deploymentMode}
                            buttonStyle="solid"
                            onChange={(e) => this.setState({ deploymentMode: e.target.value })}
                        >
                            <Radio.Button value="server">服务器部署</Radio.Button>
                            <Radio.Button value="local">仅本地运行</Radio.Button>
                        </Radio.Group>
                    </div>
                    <div>
                        <div className="profile-vibe-form-label">主体</div>
                        <Radio.Group
                            value={businessSubject}
                            buttonStyle="solid"
                            onChange={(e) => this.setState({ businessSubject: e.target.value })}
                        >
                            <Radio.Button value="lechun">乐纯</Radio.Button>
                            <Radio.Button value="superbody">超体</Radio.Button>
                        </Radio.Group>
                    </div>
                </Space>
            </Modal>
        )
    }

    renderDetailDrawer = () => {
        const { detailVisible, detailLoading, selectedDetail, retryLoading } = this.state
        const selectedStatus = (selectedDetail?.status || '').toLowerCase()
        const selectedFailed = selectedStatus === 'failed'
        const datasetProject = this.getProjectKind(selectedDetail) === 'dataset'
        const serverDeployment = !datasetProject && this.getDeploymentMode(selectedDetail) === 'server'
        const dynamicProjectInstruction = !datasetProject && selectedDetail?.id
            ? buildVibeProjectCodexPrompt(selectedDetail.id) : ''
        const initInstruction = serverDeployment ? dynamicProjectInstruction : ''
        const localInitInstruction = serverDeployment
            ? '' : (datasetProject
                ? this.formatVibeInstructionText(selectedDetail?.localInitInstructionMd)
                : dynamicProjectInstruction)
        const hasInstructions = !!(initInstruction || localInitInstruction)
        return (
            <Drawer
                width={datasetProject ? 960 : 760}
                className="profile-vibe-detail-drawer"
                visible={detailVisible}
                onClose={() => this.setState({ detailVisible: false, selectedDetail: null })}
                bodyStyle={{ padding: 20, background: '#f5f7fb' }}
                title={selectedDetail?.projectName || 'Vibe 项目详情'}
            >
                {detailLoading ? (
                    <div className="profile-vibe-detail-loading"><Spin /></div>
                ) : selectedDetail ? (
                    <Space direction="vertical" size={16} style={{ width: '100%' }}>
                        <Card bordered={false} className="profile-vibe-detail-card">
                            <div className="profile-vibe-card-head">
                                <div className="profile-vibe-card-title">项目信息</div>
                                {selectedFailed ? (
                                    <Button
                                        type="primary"
                                        icon={<ReloadOutlined />}
                                        loading={retryLoading}
                                        onClick={this.retryProject}
                                    >
                                        重试接入
                                    </Button>
                                ) : null}
                            </div>
                            <Descriptions column={2} size="small">
                                <Descriptions.Item label="项目名称">{selectedDetail.projectName || '-'}</Descriptions.Item>
                                <Descriptions.Item label="状态">{this.renderStatusTag(selectedDetail.status)}</Descriptions.Item>
                                <Descriptions.Item label="项目用途">{this.renderProjectKindTag(selectedDetail)}</Descriptions.Item>
                                <Descriptions.Item label="运行方式">{this.renderDeploymentModeTag(selectedDetail)}</Descriptions.Item>
                                <Descriptions.Item label="主体">{this.renderBusinessSubjectTag(selectedDetail)}</Descriptions.Item>
                                <Descriptions.Item label="Slug"><Text code>{selectedDetail.projectSlug || '-'}</Text></Descriptions.Item>
                                <Descriptions.Item label="项目简介/备注" span={2}>
                                    {selectedDetail.description || <Text type="secondary">暂无简介或备注</Text>}
                                </Descriptions.Item>
                                <Descriptions.Item label="创建时间">{this.formatDate(selectedDetail.createTime)}</Descriptions.Item>
                                <Descriptions.Item label={datasetProject ? '共享 MySQL 数据库' : 'MySQL 数据库'}>
                                    <Text code copyable={!!selectedDetail.mysqlDatabaseName}>{selectedDetail.mysqlDatabaseName || '-'}</Text>
                                </Descriptions.Item>
                                <Descriptions.Item label="数据库状态">
                                    {this.renderMysqlStatusTag(selectedDetail.mysqlDatabaseStatus)}
                                </Descriptions.Item>
                                {serverDeployment ? <Descriptions.Item label="访问地址" span={2}>
                                    <Text copyable={!!selectedDetail.publicUrl}>{selectedDetail.publicUrl || '-'}</Text>
                                </Descriptions.Item> : null}
                                {serverDeployment ? <Descriptions.Item label="basePath"><Text code>{selectedDetail.basePath || '-'}</Text></Descriptions.Item> : null}
                                <Descriptions.Item label="最近接入">{this.formatDate(selectedDetail.lastProvisionedAt)}</Descriptions.Item>
                            </Descriptions>
                        </Card>
                        {datasetProject ? (
                            <VibeDatasetPanel
                                projectId={selectedDetail.id}
                                onUpdated={this.refreshSelectedDetail}
                                onManagePermissions={this.manageSelectedProjectPermissions}
                            />
                        ) : null}
                        {hasInstructions ? (
                            <Card bordered={false} className="profile-vibe-detail-card">
                                <div className="profile-vibe-card-title">
                                    <CopyOutlined /> {datasetProject ? '项目初始化提示词' : '项目初始化启动提示词'}
                                </div>
                                <Collapse
                                    bordered={false}
                                    defaultActiveKey={[]}
                                    className="profile-vibe-bootstrap-collapse profile-vibe-detail-instruction-collapse"
                                >
                                    {serverDeployment ? this.renderInstructionPanel(
                                        'deploy',
                                        '服务器部署项目启动提示词',
                                        '（Codex 将通过接口获取最新完整提示词）',
                                        initInstruction,
                                    ) : null}
                                    {!serverDeployment ? this.renderInstructionPanel(
                                        'local',
                                        datasetProject ? 'AIC 数据项目提示词' : '仅本地运行项目启动提示词',
                                        datasetProject
                                            ? '（AIC 数据登记项目）'
                                            : '（Codex 将通过接口获取最新完整提示词）',
                                        localInitInstruction,
                                    ) : null}
                                </Collapse>
                            </Card>
                        ) : null}
                        {selectedFailed && selectedDetail.provisionError ? (
                            <Card bordered={false} className="profile-vibe-detail-card">
                                <div className="profile-vibe-card-title">接入失败原因</div>
                                <pre className="profile-vibe-error">{selectedDetail.provisionError}</pre>
                            </Card>
                        ) : null}
                        {selectedFailed && selectedDetail.mysqlDatabaseError ? (
                            <Card bordered={false} className="profile-vibe-detail-card">
                                <div className="profile-vibe-card-title">数据库配置失败原因</div>
                                <pre className="profile-vibe-error">{selectedDetail.mysqlDatabaseError}</pre>
                            </Card>
                        ) : null}
                    </Space>
                ) : null}
            </Drawer>
        )
    }

    render() {
        const { loading, loadError, summary, projects } = this.state
        const spaceEnabled = summary?.spaceEnabled !== undefined ? !!summary.spaceEnabled : !!summary?.gitlabEnabled

        if (loadError) {
            return (
                <Result
                    status="error"
                    title="VibeCoding 空间加载失败"
                    subTitle="无法获取项目列表，请稍后重试"
                    extra={<Button type="primary" onClick={this.loadData}>重试</Button>}
                />
            )
        }

        return (
            <div className="profile-vibe-wrap">
                <Spin spinning={loading}>
                    {this.renderAccountCard()}
                    {this.renderDatasetBootstrapPrompt()}
                    {spaceEnabled ? (
                        <>
                            <div className="profile-vibe-toolbar">
                                <div className="profile-market-toolbar-title">我的 VibeCoding 项目</div>
                                <Space>
                                    <Button icon={<ReloadOutlined />} onClick={this.loadData}>刷新</Button>
                                    <Button type="primary" icon={<PlusOutlined />} onClick={this.openCreate}>新增项目</Button>
                                </Space>
                            </div>
                            {projects.length > 0 ? (
                                <div className="profile-vibe-grid">
                                    {projects.map(this.renderProjectCard)}
                                </div>
                            ) : (
                                <Card bordered={false} className="profile-vibe-empty-card">
                                    <Empty description="暂无 VibeCoding 项目" />
                                </Card>
                            )}
                        </>
                    ) : null}
                    {this.renderCreateModal()}
                    {this.renderDetailDrawer()}
                    <VibeProjectDeleteDialog
                        visible={this.state.deleteVisible}
                        project={this.state.deleteProject}
                        onClose={this.closeProjectDelete}
                        onDeleted={this.loadData}
                    />
                </Spin>
            </div>
        )
    }
}

class Profile extends Component {
    state = {
        userInfo: null,
        loading: true,
        loadError: false,
    }

    componentDidMount() {
        this.loadUserDetail()
    }

    loadUserDetail = () => {
        this.setState({ loading: true, loadError: false })
        getUserDetail({})
            .then(res => {
                this.setState({ userInfo: res, loading: false })
            })
            .catch(() => {
                this.setState({ loading: false, loadError: true })
            })
    }

    getActiveTab = () => {
        const search = new URLSearchParams(this.props.location?.search)
        return search.get('tab') || 'info'
    }

    handleTabChange = (key) => {
        const { history, location } = this.props
        const search = new URLSearchParams(location?.search)
        search.set('tab', key)
        history.replace({ pathname: location.pathname, search: search.toString() })
    }

    handleConfigureVibePageAccess = (project) => {
        const search = new URLSearchParams()
        if (project?.id) search.set('projectId', String(project.id))
        if (project?.projectSlug) search.set('keyword', project.projectSlug)
        this.props.history.push({
            pathname: '/admin/vibePageAccess',
            search: search.toString(),
        })
    }

    handleManageVibeProjectPermissions = (projectId) => {
        const { history, location } = this.props
        const search = new URLSearchParams(location?.search)
        search.set('tab', 'vibeprojects')
        search.set('authorizeProjectId', String(projectId))
        history.replace({ pathname: location.pathname, search: search.toString() })
    }

    toPassword = () => {
        this.props.history.push('/portal/password')
    }

    render() {
        const { userInfo, loading, loadError } = this.state
        const activeTab = this.getActiveTab()
        const userId = userInfo?.userId || userInfo?.id
        const nickName = userInfo?.userNick || userInfo?.nickName || '-'
        const loginName = userInfo?.userName || userInfo?.loginName || '-'

        if (loadError) {
            return (
                <Result
                    status="error"
                    title="加载失败"
                    subTitle="无法获取用户信息，请刷新重试"
                    extra={<Button type="primary" onClick={this.loadUserDetail}>重试</Button>}
                />
            )
        }

        return (
            <div className="profile-wrap">
                <Spin spinning={loading}>
                    {/* 顶部横幅 */}
                    <div className="profile-banner">
                        <div className="profile-banner-inner">
                            <Avatar
                                size={80}
                                src={userInfo?.avatar}
                                icon={<UserOutlined />}
                                className="profile-banner-avatar"
                            />
                            <div className="profile-banner-info">
                                <div className="profile-banner-name">{nickName}</div>
                                <div className="profile-banner-meta">
                                    <Tag icon={<IdcardOutlined />}>{loginName}</Tag>
                                    {userInfo?.platformGroupName && (
                                        <Tag icon={<BankOutlined />}>{userInfo.platformGroupName}</Tag>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Tab 内容区 */}
                    <div className="profile-tabs-wrap">
                        <Tabs activeKey={activeTab} onChange={this.handleTabChange} destroyInactiveTabPane>
                            <TabPane
                                tab={<span><UserOutlined />个人信息</span>}
                                key="info"
                            >
                                <InfoTab
                                    userInfo={userInfo}
                                    onTabSwitch={this.handleTabChange}
                                    onPassword={this.toPassword}
                                />
                            </TabPane>

                            <TabPane
                                tab={<span><KeyOutlined />API Key</span>}
                                key="apikey"
                            >
                                <ApiKeyManagement onlyMine={true} fixedUserId={userId} />
                            </TabPane>

                            <TabPane
                                tab={<span><AppstoreOutlined />MCP市场</span>}
                                key="mcpmarket"
                            >
                                <McpMarketTab />
                            </TabPane>

                            <TabPane
                                tab={<span><ApiOutlined />Skill市场</span>}
                                key="skillmarket"
                            >
                                <SkillMarketTab />
                            </TabPane>

                            <TabPane
                                tab={<span><CloudServerOutlined />VibeCoding 空间</span>}
                                key="vibedeploy"
                            >
                                <VibeDeployTab
                                    userInfo={userInfo}
                                    onTabSwitch={this.handleTabChange}
                                    onManageProjectPermissions={this.handleManageVibeProjectPermissions}
                                    onConfigurePageAccess={this.handleConfigureVibePageAccess}
                                />
                            </TabPane>

                            <TabPane
                                tab={<span><UnorderedListOutlined />Vibe 项目</span>}
                                key="vibeprojects"
                            >
                                <VibeProjectList userInfo={userInfo} />
                            </TabPane>

                            <TabPane
                                tab={<span><CloudServerOutlined />API市场</span>}
                                key="apimarket"
                            >
                                <ApiMarketTab />
                            </TabPane>
                        </Tabs>
                    </div>
                </Spin>
            </div>
        )
    }
}

export default withRouter(Profile)
